import PropTypes from 'prop-types';
import styles from './SearchError.module.scss';
import { useIntl } from 'react-intl';

const SearchError = ({ body, ...props }) => {
    const intl = useIntl();
    return (
        <div className="govuk-form-group govuk-form-group--error" data-testid="mapPage.search.searchError">
            <div className={['govuk-error-message', 'govuk-body-s', styles.container].join(' ')}>
                <span className="govuk-visually-hidden">{intl.formatMessage({ id: 'errorLabel' })}:</span> {body}
            </div>
        </div>
    );
};

SearchError.propTypes = {
    body: PropTypes.string,
    'data-testid': PropTypes.string
};

export default SearchError;
